<template>
    <div class="info">
        '주식회사 위트리'는(이하 '회사'는) 고객님의 개인정보를 중요시하며, "정보통신망 이용촉진 및 정보보호"에 관한 법률을 준수하고 있습니다. 회사는 개인정보취급방침을 통하여 고객님께서 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 개인정보처리방침을 개정하는 경우 웹사이트 공지사항(또는 개별공지)을 통하여 공지할 것입니다.<br/><br/>본 방침은 : 2022년 10월 1일 부터 시행됩니다.
        <h5>수집하는 개인정보 항목</h5>
        <span>회사는 회원가입을 위해 아래와 같은 개인정보를 수집하고 있습니다.</span>
        <div class="ibox">
            <p><strong>수집항목</strong>이름, 연락처, 이메일, 성별, 생년월일</p>
            <p><strong>개인정보 수집방법</strong>회원가입</p>
        </div>
        <h5>제1조(목적)</h5>
        <span>회사는 수집한 개인정보를 다음의 목적을 위해 활용합니다.</span>
        <div class="ibox">
            <p><strong>회원가입 및 관리</strong>덴탈클라우드 서비스 이용을 위한 가입, 본인확인, 부정이용방지, 비인가 사용방지 등의 목적으로 개인정보를 활용합니다.</p>
            <p><strong>본인신용정보 열람서비스 가입 및 보험 정보 제공</strong>본인신용정보 열람서비스 회원가입, 서비스 이용(보험 조회) 등의 목적으로 개인정보를 활용합니다.</p>
        </div>
        <h5>개인정보의 보유 및 이용기간</h5>
        <span>원칙적으로, 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체 없이 파기합니다. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는 아래와 같이 관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다.</span>
        <div class="ibox">
            <p>- 보존 항목 : 결제기록<br/>
            - 보존 근거 : 계약 또는 청약철회 등에 관한 기록<br/>
            - 보존 기간 : 3년<br/>
            - 계약 또는 청약철회 등에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br/>
            - 대금결제 및 재화 등의 공급에 관한 기록 : 5년 (전자상거래등에서의 소비자보호에 관한 법률)<br/>
            - 소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 (전자상거래등에서의 소비자보호에 관한 법률)</p>
        </div>
        <h5>개인정보의 파기절차 및 방법 </h5>
        <span>회사는 원칙적으로 개인정보 수집 및 이용목적이 달성된 후에는 해당 정보를 지체없이 파기합니다. 파기절차 및 방법은 다음과 같습니다. </span>
        <div class="ibox">
            <p><strong>파기절차</strong>회원님이 문의를 위해 입력하신 정보는 목적이 달성된 후 별도의 DB로 옮겨져(종이의 경우 별도의 서류함) 내부 방침 및 기타 관련 법령에 의한 정보보호 사유에 따라(보유 및 이용기간 참조) 일정 기간 저장된 후 파기되어집니다. 별도 DB로 옮겨진 개인정보는 법률에 의한 경우가 아니고서는 보유 되어지는 이외의 다른 목적으로 이용되지 않습니다. </p>
            <p><strong>파기방법</strong>전자적 파일형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</p>
        </div>
        <h5>개인정보 제공</h5>
        <span>회사는 이용자의 개인정보를 원칙적으로 외부에 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.</span>
        <div class="ibox">
            <p>- 이용자들이 사전에 동의한 경우<br/>
                - 법령의 규정에 의거하거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우</p>
        </div>
        <h5>이용자 및 법정대리인의 권리와 그 행사방법  </h5>
        <span>이용자 및 법정 대리인은 언제든지 등록되어 있는 자신 혹은 당해 만 14세 미만 아동의 개인정보를 조회하거나 수정할 수 있으며 가입해지를 요청할 수도 있습니다.</span>
        <div class="ibox">
            <p>이용자 혹은 만 14세 미만 아동의 개인정보 조회/수정을 위해서는 ‘개인정보변경’(또는 ‘회원정보수정’ 등)을 가입해지(동의철회)를 위해서는 “회원탈퇴”를 클릭하여 본인 확인 절차를 거치신 후 직접 열람, 정정 또는 탈퇴가 가능합니다. 혹은 개인정보관리책임자에게 서면, 전화 또는 이메일로 연락하시면 지체없이 조치하겠습니다.
            귀하가 개인정보의 오류에 대한 정정을 요청하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 지체없이 통지하여 정정이 이루어지도록 하겠습니다. 
            회사는 이용자 혹은 법정 대리인의 요청에 의해 해지 또는 삭제된 개인정보는 “회사가 수집하는 개인정보의 보유 및 이용기간”에 명시된 바에 따라 처리하고 그 외의 용도로 열람 또는 이용할 수 없도록 처리하고 있습니다.</p>
        </div>
        <h5>개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항 </h5>
        <span>쿠키 등 인터넷 서비스 이용 시 자동 생성되는 개인정보를 수집하는 장치를 운영하지 않습니다.</span>
        <h5>개인정보에 관한 민원서비스 </h5>
        <span>회사는 고객의 개인정보를 보호하고 개인정보와 관련한 불만을 처리하기 위하여 아래와 같이 관련 부서 및 개인정보관리책임자를 지정하고 있습니다.</span>
        <div class="ibox">
            <p> - 전화번호 : 070-7788-1458 <br/>
                - 담당자 : 이동훈 대표<br/><br/>
                    귀하께서는 회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다. </p>
        </div>
        <span>회사의 서비스를 이용하시며 발생하는 모든 개인정보보호 관련 민원을 개인정보관리책임자 혹은 담당부서로 신고하실 수 있습니다. 회사는 이용자들의 신고사항에 대해 신속하게 충분한 답변을 드릴 것입니다. <br/>
        기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다. </span>
        <div class="ibox ibox_end">
            <p> 1. 개인정보침해신고회사 (www.1336.or.kr/국번없이 118)  <br/>
                2. 정보보호마크인증위원회 (www.eprivacy.or.kr/02-580-0533~4)  <br/>
                3. 대검찰청 인터넷범죄수사회사 (http://icic.sppo.go.kr/02-3480-3600)  <br/>
                4. 경찰청 사이버테러대응회사 (www.ctrc.go.kr/02-392-0330)</p>
        </div>
    </div>
</template>
<script>
export default {
}
</script>